<template>
  <div id="app-container">
    <router-view />

    <van-tabbar v-if="showTabBar" v-model="active" placeholder>
      <van-tabbar-item
        v-for="tab in tabs"
        :key="tab.to"
        :icon="tab.icon"
        :badge="tab.badge"
        @click="onTabClick(tab)"
      >
        {{ tab.label }}
      </van-tabbar-item>
    </van-tabbar>

    <!-- 合同签署弹窗 -->
    <van-dialog
      v-model:show="contractVisible"
      title="提示"
      message="请签署平台用户合同"
      show-cancel-button
      cancel-text="取消"
      confirm-text="确认"
      @confirm="onContractConfirm"
      @cancel="contractVisible = false"
    />

  </div>
</template>

<script>
import { onContractPopup } from '@/utils/contract'

export default {
  name: 'App',
  data() {
    return {
      active: 0,
      contractVisible: false
    }
  },
  computed: {
    showTabBar() {
      return this.$route.meta.showTabBar !== false
    },
    tabs() {
      return [
        { label: '首页', icon: 'home-o', to: '/home', index: 0 },
        { label: '抢购', icon: 'shopping-cart-o', to: '/flash-sale', index: 1 },
        { label: '代理商中心', icon: 'friends-o', to: '/agent-center', index: 2 }
      ]
    }
  },
  created() {
    // 整页导航下每次加载都会执行：按当前路径初始化 tab 高亮
    this.syncActiveTab()
    onContractPopup(() => {
      if (this.$route.path !== '/contract-sign') {
        this.contractVisible = true
      }
    })
    // 整页重载/bfcache 恢复都会触发 pageshow：按当前路由重新对齐 tab 高亮
    this.onPageShow()
    window.addEventListener('pageshow', this.onPageShow)
  },
  methods: {
    // tab 切换：整页跳转（跨文档），返回时 bfcache 秒开。
    // 必须用 item 的 click 事件：@change 只在 active 变化时触发，
    // bfcache 恢复后高亮与页面错位时点"高亮 tab"会因值不变而无任何事件
    onTabClick(tab) {
      if (this.$route.path === tab.to) {
        // 已在当前页：滚动回顶，避免"点了没反应"的错觉
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      this.$goto(tab.to)
    },
    onPageShow() {
      // bfcache 恢复时快照里的 active 是离开前点击瞬间的旧值，
      // 必须按当前路由重新对齐，否则高亮与页面错位
      this.syncActiveTab()
    },
    syncActiveTab() {
      const idx = this.tabs.findIndex(t => this.$route.path === t.to)
      this.active = idx >= 0 ? idx : 0
    },
    onContractConfirm() {
      this.contractVisible = false
      this.$goto('/contract-sign')
    }
  }
}
</script>

<style>
#app-container {
  position: relative;
  min-height: 100vh;
  min-height: 100svh;
  overflow-x: hidden;
  background: #f5f6f7;
}
</style>
